module.exports = "img/videos/30.d6b488.mp4";